export default "__VITE_ASSET__73b846b6__"